module.exports = __webpack_public_path__ + "static/media/han_jac_ham_vib.649bca46.png";